let map;
let infoWindow;
let locations = [];
let markersArray = [];
const isMap = $('#map').length;
let isSlickRunning = false;

$(document).ready(function(){

    $('#stateSelector').on('change', function() {
        const state = $(this).val();
        if(state){
            if(isMap){
              $('.retailer-item').hide();
              $('.retailer-item[data-state="'+state+'"]').show();
            }
            else{
              $('.retailer-slider').slick('slickUnfilter');
              $('.retailer-item').removeClass('slider-filtered');
              
              $('.retailer-item').addClass('slider-filtered');
              $('.retailer-item[data-state="'+state+'"]').removeClass('slider-filtered');
              $('.retailer-slider').slick('slickFilter','.slider-filtered');
            }
        }
        else{
            $('.retailer-item').show();

            $('.retailer-slider').slick('slickUnfilter');
            $('.retailer-item').removeClass('slider-filtered');
        }

        resetLocations();
        if(isMap){
          clearOverlays();
          updateMarkers();
        }
    })

      function fitMapToBounds() {
        if (markersArray.length == 0) {
            return; // if there are no markers, return
        }
    
        let bounds = new google.maps.LatLngBounds();
        for (let marker of markersArray) {
            bounds.extend(marker.getPosition());
        }
        map.fitBounds(bounds);
    }


    function clearOverlays() {
        for (var i = 0; i < markersArray.length; i++ ) {
            markersArray[i].setMap(null);
        }
        markersArray.length = 0;
    }

    function setStates() {
        const states = [];

        document.querySelectorAll('.retailer-item').forEach(function(input){
            const state = $(input).find('.retailer-state').html();
            if(state && !states.includes(state)) states.push(state)
        });

        $('#stateSelector').find('option').not(':first').remove();
        $('#stateSelector option:first').attr('selected','selected');

        for(let i = 0; i < states.length; i++) {
            $('#stateSelector').append($('<option />').val(states[i]).html(states[i]));
        }
    }

    function resetLocations(){
        locations = [];

        document.querySelectorAll('.retailer-item').forEach(function(item){
            const stateVal = $('#stateSelector').val();
            if(stateVal){
                if(stateVal != $(item).data('state')){
                    return;
                }
            }
            const address = [];
            const addressLine2 = [];

            const address1 = $(item).find('.retailer-address1').html();
            const address2 = $(item).find('.retailer-address2').html();
            const city = $(item).find('.retailer-city').html();
            const state = $(item).find('.retailer-state').html();
            const zip = $(item).find('.retailer-zip').html();

            // If address1 is not empty, add it to the address array
            if (address1) address.push(address1);
            if (address2) address.push(address2);
            if (city) addressLine2.push(city);
            if (state) addressLine2.push(state);
            if (zip) address.push(zip);

            // If the address array has at least one element, join the elements together with a comma and space
            const addressString = address.length ? address.join(', ') : '';
            const addressString2 = addressLine2.length ? addressLine2.join(', ') : '';

            // find anchor href
            const href = $(item).find('.retailer-website a').attr('href');

            const location = {
                name: $(item).find('.retailer-name').html(),
                address: addressString,
                address2: addressString2,
                lat: parseFloat( $(item).data('lat') ),
                lng: parseFloat( $(item).data('long') ),
                website: href,
            };

            locations.push(location)
        });
    }

    function initSlider() {

      $('.retailer-slider').slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        dots: true,
        arrows: true,
          responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              infinite: true,
              dots: true
            }
          },
        ]
      });
      
    }

    function initMap() {
        resetLocations()
        if(isMap){
          infoWindow = new google.maps.InfoWindow();

        const mapOptions = {
            center: { lat: 39.8283, lng: -98.5795 },  // Centered on U.S.
            zoom: 4, // Zoom level for entire U.S.
            styles: getMapStyles()
        };
  
          map = new google.maps.Map(document.getElementById("map"), mapOptions);
  
          // Event listener to check for markers to display when map bounds change
          google.maps.event.addListener(map, 'bounds_changed', updateMarkers);
        }
        else{
          initSlider();
        }
        
        setStates();
    }
    initMap();

    function updateMarkers() {
        const bounds = map.getBounds();

        locations.forEach(location => {
            if (bounds.contains(new google.maps.LatLng(location.lat, location.lng))) {
                addMarker(location);
            }
        });

      // We won't do this for now.
      // fitMapToBounds();
    }

    function addMarker(location) {
        const marker = new google.maps.Marker({
            position: location,
            map: map
        });

        markersArray.push(marker)

        // Add a click event listener to the marker
        google.maps.event.addListener(marker, 'click', function() {
            // Set the content for the info window
            infoWindow.setContent(`
                        <div>
                            <strong>${location.name}</strong><br>
                            <p>${location.address}<br>${location.address2}</p>
                            <br>
                            ${location.website ? '<a href="'+location.website +'">Visit Website</a>' : ''}
                        </div>`);

            // Open the info window at the marker
            infoWindow.open(map, marker);
        });
    }

    function getMapStyles(){

      return [
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e9e9e9"
                    },
                    {
                        "lightness": 17
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 17
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 29
                    },
                    {
                        "weight": 0.2
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 18
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#dedede"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "saturation": 36
                    },
                    {
                        "color": "#333333"
                    },
                    {
                        "lightness": 40
                    }
                ]
            },
            {
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f2f2f2"
                    },
                    {
                        "lightness": 19
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 17
                    },
                    {
                        "weight": 1.2
                    }
                ]
            }
        ];
      
    }
})